/**
 * Datadog has the ability to discriminate across different types of errors if you encode specific metadata into your
 * error types. This function allows you to create a specific named error so that you can descriminate it in Datadog
 * RUM reporting.
 */
export const createDatadogError = (errorName: string, errorMessagePrefix?: string) => {
    class CustomDatadogNamedError extends Error {
        type = `${errorName}Error`;
        constructor(errorMessage: string) {
            const prefixedMessage = errorMessagePrefix ? `${errorMessagePrefix} ${errorMessage}` : `${errorMessage}`;
            super(prefixedMessage);
            this.type = `${errorName}Error`;
            this.name = `${errorName}Error`;
            this.message = prefixedMessage;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this as any).__proto__ = CustomDatadogNamedError.prototype;
        }
    }
    return CustomDatadogNamedError;
};
